<template>
    <div class="detail">
        <div class="nav">
          <go-back
            class="pa go-back"
          ></go-back>
          <span
                  class="item fs16 font333 pointer"
                  v-for="(item,index) of navList"
                  :key="index"
                  @click="tabChange(item)"
                  :class="{ on: getActive(item) }"
          >{{item.name}}</span>
        </div>
        <div class="view-outer pc-padding30-mobil-padding20">
            <router-view
                    :business-type="businessType"
                    :account-mt-id="+$route.params.mtid"
            ></router-view>
        </div>
    </div>
</template>

<script>
  import { getTraderOverview } from '@/api/copy'
  import { setIsMaster } from '@/utils/common'
    import { mapGetters } from 'vuex';
  export default {
    name: 'index',
    data() {
      let _this = this;
      return {
        navList: [
          {
            name: _this.$t('Overview'),
            routerName: 'generalOverview'
          },
          {
            name: _this.$t('Copy_settings'),
            routerName: 'generalFollowSetting',
          },
        ],
        businessType: 0
      };
    },
    created(){
      setIsMaster(this,true);
      this.queryMtInfo();
    },
    mounted() {
      let reouterview = document.getElementById('routerview');
      if(!reouterview) return;
      reouterview.classList.add('no-padding-import');
    },
    beforeDestroy(){
      let reouterview = document.getElementById('routerview');
      if(reouterview){
        reouterview.classList.remove('no-padding-import');
      }
      this.$store.commit('setDetailsIsMaster', true);
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
    },
    methods: {
      queryMtInfo(){
        getTraderOverview({
          mtId: this.$route.params.mtid,
        }).then((res) => {
          this.businessType = res.data.businessType;
        })
      },
      tabChange(item){
        this.$router.push({name: item.routerName})
      },
      getActive(item){

        return item.routerName == this.$route.name;
      },
    }
  };
</script>

<style lang="scss" scoped>
.detail {

}
</style>
